<template>
  <div id="reportComparativeComponent">
  <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex class="text-sm-left">
          <h2 class="primary--text font-weight-black" v-if="comparativeTitle && comparative">
            {{comparativeTitle}} - {{periodTitle}}
          </h2>
        </v-flex>
         <v-flex class="ml-2 text-xs-right">
          <v-btn v-if="periodType === 1 || periodType === 2" @click="reporte" :loading="loadingDownload" :disabled="!comparative" round outline color="primary" class="text-xs-center">
            <v-icon left>cloud_download</v-icon>
            {{ $t('general.downloadReport') }}
          </v-btn>
          <v-btn @click="send" :disabled="loading" :loading="loading" color="primary" depressed round>
            {{ $t('general.filter') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="ml-2" xs2>
          <v-select v-model="item.type" :items="comparativeTypes" :rules="rules.required" :label="$t('reportComparative.type')" @change="changeType" item-value="value" item-text="name" class="fixed-height" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-if="item.type === 'users'" v-model="item.specific" :items="users" :label="$t('general.user')" item-value="id" item-text="name" class="fixed-height" solo></v-select>
          <v-select v-if="item.type === 'categories'" v-model="item.specific" :items="categories" :label="$t('general.category')" item-value="id" item-text="name" class="fixed-height" solo></v-select>
          <v-select v-if="item.type === 'projects'" v-model="item.specific" :items="projects" :label="$t('general.projects')" item-value="id" item-text="name" class="fixed-height" solo>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="periodType" :items="periodTypes" :rules="rules.required" :label="$t('reportComparative.periodType')" item-value="id" item-text="name" class="fixed-height" solo></v-select>
        </v-flex>
        <v-flex v-if="periodType === 1" class="ml-2" xs3>
          <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="0" lazy transition="scale-transition" offset-y full-width min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="item.date1" :rules="rules.required" :label="$t('reportComparative.firstDate')" prepend-icon="event" readonly v-on="on" class="fixed-height-textfield" outline></v-text-field>
          </template>
            <v-date-picker v-model="item.date1" enabled color="primary" type="month" :locale="$t('general.locale')">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex v-if="periodType === 1" class="ml-2" xs3>
          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="true" :nudge-right="0" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="item.date2" :rules="rules.required" :label="$t('reportComparative.secondDate')" prepend-icon="event" readonly v-on="on" class="fixed-height-textfield" outline></v-text-field>
            </template>
            <v-date-picker v-model="item.date2" :min="item.date1" color="primary" type="month" :locale="$t('general.locale')">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex v-if="periodType === 2" class="ml-2" xs2>
          <v-text-field v-model="item.year1" :label="$t('reportComparative.firstDate')" :rules="rules.noSpace" mask="####"  class="fixed-height-textfield" outline></v-text-field>
        </v-flex>
        <v-flex v-if="periodType === 2" class="ml-2" xs3>
          <v-select v-model="item.quarter1" :items="quarters" :rules="rules.required" :label="$t('reportComparative.quarter')" item-value="id" item-text="text" class="fixed-height-textfield" outline></v-select>
        </v-flex>
        <v-flex v-if="periodType === 2" class="ml-2" xs2>
          <v-text-field v-model="item.year2" :label="$t('reportComparative.secondDate')" :rules="rules.noSpace" mask="####" class="fixed-height-textfield" outline></v-text-field>
        </v-flex>
        <v-flex v-if="periodType === 2" class="ml-2" xs3>
          <v-select v-model="item.quarter2" :items="quarters" :rules="rules.required" :label="$t('reportComparative.quarter')" item-value="id" item-text="text" class="fixed-height-textfield" outline></v-select>
        </v-flex>
       
      </v-layout>
      <br>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-data-table
        v-if="comparative && !loadingItems"
        :headers="periodType === 2 ? headers2 : headers"
        :items="information"
        class="elevation-3"
        :loading="loadingItems"
        :pagination.sync="pagination"
        hide-actions
        no-data-text="">
        <template v-slot:no-data v-if="information.length > 0">
          <center class="title font-weight-light">{{$t('general.noDataText')}}</center>
        </template>
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <td class="text-xs-center">{{ item.type === 'categories' ? props.item.type : props.item.type}}</td>
          <td class="text-xs-center">{{ props.item.total1 | formatCurrency }}</td>
          <td class="text-xs-center">{{ props.item.total2 | formatCurrency }}</td>
          <td class="text-xs-center">{{ Math.abs(props.item.total1 - props.item.total2) | formatCurrency }}</td>
          <td class="text-xs-center">
            <v-icon v-if="parseFloat(props.item.total1) < parseFloat(props.item.total2)" color="green">arrow_upward</v-icon>
            <v-icon v-if="parseFloat(props.item.total1) > parseFloat(props.item.total2)" color="red">arrow_downward</v-icon>
            {{getDifferenceSign(props.item.total1, props.item.total2,rounded(getDifference(props.item.total1, props.item.total2)))}}%</td>
        </template>
        <template v-slot:footer>
          <td class="text-xs-center">
            <strong> {{ $t('general.totalExpenses') }} </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{comparative.comparative1.total | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{comparative.comparative2.total | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <strong> {{ Math.abs(comparative.comparative1.total - comparative.comparative2.total) | formatCurrency}} </strong>
          </td>
          <td class="text-xs-center">
            <v-icon v-if="parseFloat(comparative.comparative1.total) < parseFloat(comparative.comparative2.total)" color="green">arrow_upward</v-icon>
            <v-icon v-if="parseFloat(comparative.comparative1.total) > parseFloat(comparative.comparative2.total)" color="red">arrow_downward</v-icon>
            <strong>{{rounded(comparative.diference.percentage)}}% </strong>
          </td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'reportComparativeComponent',
  data () {
    return {
      menu: false,
      menu2: false,
      item: {
        date1: new Date().getMonth() === 0 ? `${new Date().getFullYear() - 1}-12` : `${new Date().getFullYear()}-${String(new Date().getMonth()).padStart(2, '0')}`,
        date2: new Date().toISOString().substr(0, 7),
        year1: parseInt(new Date().toISOString().substr(5, 2)) === 1 ? parseInt(new Date().toISOString().substr(0, 4)) - 1 : new Date().toISOString().substr(0, 4),
        month1: parseInt(new Date().toISOString().substr(5, 2)) === 1 ? '12' : new Date().toISOString().substr(5, 2),
        year2: new Date().toISOString().substr(0, 4),
        month2: new Date().toISOString().substr(5, 2),
        quarter1: null,
        quarter2: null,
        specific: null,
        type: 'users'
      },
      users: [],
      categories: [],
      projects: [],
      allUsers: true,
      allCategories: true,
      allProjects: true,
      periodType: 1,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 100, // -1 for All",
        totalItems: 0,
        sortBy: 'id'
      },
      comparative: null,
      valid: true,
      loading: false,
      loadingItems: true,
      dialog: false,
      information: [],
      type: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      loadingDownload: false
    }
  },
  computed: {
    heading () {
      return this.$t('reportComparative.name')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: this.comparativeTitle,
          align: 'center',
          value: 'type',
          sortable: true
        },
        {
          text: this.item.date1,
          align: 'center',
          value: 'total1',
          sortable: true
        },
        {
          text: this.item.date2,
          align: 'center',
          value: 'total2',
          sortable: true
        },
        {
          text: this.$t('reportComparative.differenceAmount'),
          align: 'center',
          value: '',
          sortable: true
        },
        {
          text: this.$t('reportComparative.differencePercentage'),
          align: 'center',
          value: '',
          sortable: true
        }
      ]
    },
    headers2 () {
      const headerTotal1 = this.quarters.find(item => item.id === this.item.quarter1)
      const headerTotal2 = this.quarters.find(item => item.id === this.item.quarter2)
      
      return [
        {
          text: this.comparativeTitle,
          align: 'center',
          value: 'type',
          sortable: true
        },
        {
          text: this.item.date1 && headerTotal1 ? this.item.year1 + ' - ' + headerTotal1.text : this.item.date1 + '-',
          align: 'center',
          value: 'total1',
          sortable: true
        },
        {
          text: this.item.date2 && headerTotal2 ? this.item.year2 + ' - ' + headerTotal2.text : this.item.date2 + '-',
          align: 'center',
          value: 'total2',
          sortable: true
        },
        {
          text: this.$t('reportComparative.differenceAmount'),
          align: 'center',
          value: '',
          sortable: true
        },
        {
          text: this.$t('reportComparative.differencePercentage'),
          align: 'center',
          value: '',
          sortable: true
        }
      ]
    },
    rules () {
      return this.$validationRules()
    },
    comparativeTypes () {
      return [
        {
          id: 1,
          name: this.$t('general.users'),
          value: 'users'
        },
        {
          id: 2,
          name: this.$t('general.categories'),
          value: 'categories'
        },
        {
          id: 3,
          name: this.$t('general.projects'),
          value: 'projects'
        }
      ]
    },
    periodTypes () {
      return [
        {
          id: 1,
          name: this.$t('dashboard.monthly')
        },
        {
          id: 2,
          name: this.$t('dashboard.quarter')
        }
      ]
    },
    quarters () {
      return [
        {
          id: 1,
          text: this.$t('reportComparative.firstQuarter')
        },
        {
          id: 2,
          text: this.$t('reportComparative.secondQuarter')
        },
        {
          id: 3,
          text: this.$t('reportComparative.thirdQuarter')
        },
        {
          id: 4,
          text: this.$t('reportComparative.fourthQuarter')
        }
      ]
    },
    comparativeTitle () {
      switch (this.item.type) {
        case 'users': return this.$t('general.users')
        case 'categories': return this.$t('general.categories')
        case 'projects': return this.$t('general.projects')
        default: return this.$t('general.users')
      }
    },
    periodTitle () {
      switch (this.periodType) {
        case 1: return this.$t('dashboard.monthly')
        case 2: return this.$t('dashboard.quarter')
        default: return this.$t('dashboard.monthly')
      }
    },
    modelName () {
      if (this.item.model != null) {
        return this.item.model.name
      }
    }
  },
  watch: {
    'item.date1' () {
      // let month = parseInt(new Date().toISOString().substr(5, 2))
      // if (month === 1) {
      //   this.item.date1 = parseInt(new Date().toISOString().substr(0, 5)) - 1 + '-12'
      // }
      this.item.year1 = this.item.date1.substr(0, 4)
      this.item.month1 = this.item.date1.substr(5, 2)
    },
    'item.date2' () {
      this.item.year2 = this.item.date2.substr(0, 4)
      this.item.month2 = this.item.date2.substr(5, 2)
    },
    '$store.state.userLogged' () {
      if (this.$store.state.userLogged.company) {
        this.get()
      }
    },
    allUsers () {
      if (this.allUsers) {
        this.item.specific = null
      } else if (this.allUsers === null) {
        this.item.specific = this.users[0].id
      }
    },
    allCategories () {
      if (this.allCategories) {
        this.item.specific = null
      } else if (this.allCategories === null) {
        this.item.specific = this.categories[0].id
      }
    },
    allProjects () {
      if (this.allProjects) {
        this.item.specific = null
      } else if (this.allProjects === null) {
        this.item.specific = this.projects[0].id
      }
    },
    periodType () {
      if (this.periodType === 1) {
        this.item.quarter1 = null
        this.item.quarter2 = null
        this.item.month1 = parseInt(new Date().toISOString().substr(5, 2)) - 1
        this.item.month2 = new Date().toISOString().substr(5, 2)
      } else {
        this.item.month1 = null
        this.item.month2 = null
      }
    }
  },
  created () {
    if (this.$store.state.userLogged.company) {
      this.get()
    }
  },
  methods: {
    changeType() {
      this.item.specific = null
    },      
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    getDifference (val1, val2) {
      let calc = 0
      if (val1 === 0) {
        calc = val2
      } else if (val2 === 0) {
        calc = val1
      } else {
        calc = (Math.abs(val1 - val2) / val1) * 100
      }
      // let percent = calc.toString()
      // let rounded = 0
      // if (percent.indexOf('.')) {
      //   rounded = percent.substr(0, percent.indexOf('.') + 3)
      // }
      // console.log(percent.indexOf('.'))
      return calc
    },
    getDifferenceSign (val1, val2, percentage) {
      let difference = ''
      val1 = parseFloat(val1)
      val2 = parseFloat(val2)
      if (val1 === val2) {
        difference = percentage
      } else if (val1 === 0) {
        difference = '+100'
      } else if (val2 === 0) {
        difference = '-100'
      } else if (val1 < val2) {
        difference = '+' + percentage
      } else {
        difference = '-' + percentage
      }
      return difference
    },
    rounded (item) {
      let number = item.toString()
      let rounded = null
      if (number.indexOf('.')) {
        rounded = number.substr(0, number.indexOf('.') + 3)
      }
      return rounded
    },
    send () {
      if (this.periodType === 1 && !this.item.date1 && !this.item.date2) return this.showNotification(this.$t('general.selectDates'), 'error', -1) 
      
      if (this.periodType === 2 && !this.item.quarter1 && !this.item.quarter2) return this.showNotification(this.$t('reportComparative.selectQuarter'), 'error', -1)

      this.loadingItems = true
      this.loading = true
      
      this.$emit('send', {
        item: this.item,
        company_id: this.$store.state.userLogged.company[0].id,
        context: this
      })
      
    },
    close () {
      this.dialog = false
      this.loadingItems = false
    },
    resetForm () {
      this.periodType = 1
      this.item.type = 'users'
      this.comparative = null
    },
    organizeInformation () {
      this.information = []
      if (this.comparative != null) {
        if (this.comparative.comparative1 != null && this.comparative.comparative1 !== undefined) {
          if (this.comparative.comparative1.expenses.length > 0) {
            this.comparative.comparative1.expenses.forEach(item => {
              // let type = item.user ? item.user : item.category
              let type = ''
              if (item.user) {
                type = item.user
              } else if (item.category) {
                type = item.category
              } else if (item.project) {
                type = item.project
              }
              let info = { type: type, 'total1': item.total, 'total2': 0 }
              this.information.push(info)
            })
          }
        }
        if (this.comparative.comparative2 != null && this.comparative.comparative2 !== undefined) {
          if (this.comparative.comparative2.expenses.length > 0) {
            this.comparative.comparative2.expenses.forEach(item => {
              // let type = item.user ? item.user : item.category
              let type = ''
              if (item.user) {
                type = item.user
              } else if (item.category) {
                type = item.category
              } else if (item.project) {
                type = item.project
              }
              let found = null
              if (this.information.length > 0) {
                found = this.information.find(function (element) {
                  return element.type === type
                })
              }
              if (found !== undefined && found !== null) {
                found.total2 = item.total
              } else {
                let info = { type: type, 'total1': 0, 'total2': item.total }
                this.information.push(info)
              }
            })
          }
        }
      }
    },
    reporte () {
      this.loadingDownload = true
      this.$emit('downloadReport', {
        item: this.item,
        company_id: this.$store.state.userLogged.company[0].id,
        context: this
      })
    },
    get () {
      this.$emit('get', {context: this, company_id: this.$store.state.userLogged.company[0].id})
      if (this.$store.state.userLogged.company) {
        this.$emit('send', {
          item: this.item,
          company_id: this.$store.state.userLogged.company[0].id,
          context: this
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reportComparative.component.vue